import { useParams } from 'react-router-dom';

export function useOpeningSlug() {
  const { openingSlug } = useParams();

  if (!openingSlug) throw new Error('Missing openingSlug');

  return openingSlug;
}
